import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { BranchModel } from "@core/api/models/branch.model";
import { Branch, BranchAdapter} from "./branch.model";

export class Client{
  constructor(
    public id:string,
    public name:string = "",
    public branches:Branch[] = []
  ){}

  getActiveBranches():Branch[]{
    let branches = this.branches.filter(y => y.active);
    branches.sort((a,b) => a.name.localeCompare(b.name));
    return branches;
  }
}


@Injectable({
  providedIn: 'root'
})

export class ClientAdapter implements Adapter<Client> {
  
  adapt(item: any): Client {
    return new Client(
      item.id,
      item.publicName
    );
  }
}
